import { render, staticRenderFns } from "./operationalStatistics.vue?vue&type=template&id=0851ab84&scoped=true"
import script from "./operationalStatistics.vue?vue&type=script&lang=js"
export * from "./operationalStatistics.vue?vue&type=script&lang=js"
import style0 from "./operationalStatistics.vue?vue&type=style&index=0&id=0851ab84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0851ab84",
  null
  
)

export default component.exports